import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      criticalities: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Criticidade',

          align: 'center',
          value: 'criticality',
        },
        {
          text: 'TAI',

          align: 'center',
          value: 'totalServiceTime',
        },
        {
          text: 'O.S.',

          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'TAI Média',

          align: 'center',
          value: 'avgServiceTime',
        },
      ],
      mobileHeader: [
        {
          text: 'Criticidade',

          align: 'center',
          value: 'criticality',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listServiceTime()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `service_Time_Criticality_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/serviceTimeCriticality', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listServiceTime() {
      this.loading = true
      await this.apiService
        .post('reports/serviceTimeByCriticalty', this.filterProp)
        .then((response) => {
          this.showChart = response.content.objects.length > 0
          this.criticalities = response.content.objects
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listServiceTime()
    },
  },
}
